// Rough plain-text excerpt of an HTML (Quill) body, for table cells and for
// "is there anything in here?" checks. Not a sanitiser — never feed its output
// back into the DOM as markup.
export const stripHtml = (html: string) =>
  html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();
